export const FEEDBACK_TYPES = {
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
    REMOVE_POSITIVE: 'remove-positive',
    REMOVE_NEGATIVE: 'remove-negative'
};